import {
  Box,
  Typography,
  TypographyProps,
  makeStyles,
} from '@material-ui/core';
import { WbTooltip } from '../WbTooltip';
import clsx from 'clsx';
import { CSSProperties, FC, ReactNode } from 'react';
import { WbCardVariant } from './WbCard';

type WbCardHeaderProps = {
  className?: string;
  style?: CSSProperties;
  contentClassname?: string;
  contentStyle?: CSSProperties;
  titleContentClassname?: string;
  titleContainerStyle?: CSSProperties;
  title: ReactNode;
  titleId?: string;
  icon?: JSX.Element;
  actions?: ReactNode;
  leading?: JSX.Element;
  typographyProps?: TypographyProps;
  variant?: WbCardVariant;
};

type UseStylesProps = {
  variant: WbCardVariant;
};

const useStyles = makeStyles<any, UseStylesProps>(
  theme => ({
    header: ({ variant }) => {
      const variants = {
        default: {
          color: theme.palette.black,
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
        },
        secondary: {
          background: theme.palette.bkg.primary,
          color: theme.palette.primary.main,
          borderBottom: 'none',
        },
      };

      return {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        overflowX: 'auto',
        overflowY: 'hidden',
        ...variants[variant],
      };
    },
    headerContent: ({ variant }) => {
      const variants = {
        default: {
          height: '48px',
          padding: '8px 12px',
        },
        secondary: {
          height: '48px',
          padding: '8px 12px',
        },
      };

      return {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        width: '100%',
        ...variants[variant],
      };
    },
    headerTitleContent: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      flex: '1 1 0',
      overflow: 'hidden',
    },
  }),
  { name: 'WbCardHeader' },
);

export const WbCardHeader: FC<WbCardHeaderProps> = ({
  className,
  style,
  contentClassname,
  contentStyle,
  titleContentClassname,
  titleContainerStyle,
  title,
  titleId,
  icon,
  actions,
  leading,
  typographyProps,
  variant = 'default',
}) => {
  const classes = useStyles({ variant });

  return (
    <Box className={clsx(classes.header, className)} style={style}>
      {leading}
      <Box
        className={clsx(classes.headerContent, contentClassname)}
        style={contentStyle}
      >
        <Box
          className={clsx(classes.headerTitleContent, titleContentClassname)}
          style={titleContainerStyle}
          id={titleId}
        >
          {typeof title === 'string' ? (
            <WbTooltip title={title}>
              <Typography
                style={{ fontWeight: 500, maxWidth: '100%' }}
                noWrap
                {...typographyProps}
              >
                {title}
              </Typography>
            </WbTooltip>
          ) : (
            title
          )}
          {icon}
        </Box>
        {actions}
      </Box>
    </Box>
  );
};
